import {
  Component, HostListener, Input, OnInit,
  ViewChild

} from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { MessageService } from "primeng/primeng";
import { ChallengeService } from "../challenge.service";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { Observable } from "rxjs";
import { FormFields } from "app/views/campaign-3/components/form-fields/form-fields.component";
import { ChallengeDetail, ChallengeDetailElaborated, ChallengeExportReportDTO, ChallengeResponse, OverviewPartecipantsDTO, OverviewPayload, ParticipantOverviewResponse } from "../challenge.model";
import { Campaign3KontableComponent } from "app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component";
import { Campaign3BreadcrumbComponent } from "app/views/campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component";
import { KontableComponent } from "app/modules/UIKit/components/kontable/kontable.component";
import { ChallengeOverviewService } from "../challenge-overview.service";
import { DatePipe } from "@angular/common";
import { catchError } from "rxjs/operators";
import { ChallengeOverviewExportService } from "../challenge-overview-export.service";
import * as FileSaver from 'file-saver';
import { ApiMethods, Permission, PermissionConfiguration } from "app/models/permission.model";
import { PermsService } from "app/services/utils/perms.service";



@Component({
  selector: 'app-challenge-graphics-details',
  templateUrl: './challenge-graphics-details.component.html',
  styleUrls: ['./challenge-graphics-details.component.css']
})


export class ChallengeGraphicsDetails implements OnInit {


  showTable: boolean = false;
  showTableExport: boolean = false;
  //UI
  breadcrumbs: Array<BreadCrumbModel> = [];
  showBreadCrumb: boolean = false;


  // ==============================
  // VARIABILI
  // ==============================
  readyTable: boolean = false;

  paginationType = KontableComponent.ServerPagination;
  dateFilter = KontableComponent.DateFilter;
  numberFilter = KontableComponent.NumberFilter;
  textFilter = KontableComponent.TextFilter;
  selectFilter = KontableComponent.SelectFilter;
  noFilter = KontableComponent.NoFilter;

  readyAcm = true;

  showMenu: boolean = false;
  currentOpenedRow: number | null = null;
  // Challenge dropdown
  challengeList: ChallengeResponse[] = []

  //partecipanti table
  isLoadingParticipants = false;
  showParticipantsTable = false;
  participantsError = false;

  fieldModel: {
    searchChallenge: ChallengeResponse,
    searchLevel: { value: number; label: string }
    searchDateStart: Date,
    searchEndDate: Date,
    acm: any,
    minBalance: number,
    maxBalance: number

  }

  // Date fields

  challengeDetailList: ChallengeDetail[] = []
  challengeDetailListElaborated: ChallengeDetailElaborated[] = [];
  levelsList: { value: number; label: string }[] = [];
  reportStateList: Array<{ value: string; label: string }> = [];


  partecipantOverviewList: ParticipantOverviewResponse[] = []
  // ==============================
  // SEARCH FORM - TEMPLATE REFS
  // ==============================
  @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
  @ViewChild('challengeField') challengeField: FormFields;
  @ViewChild('start_date_field') startDateField: FormFields;
  @ViewChild('end_date_field') endDateField: FormFields;
  @ViewChild('acmField') acmField: FormFields;
  @ViewChild('minBalance') minBalanceField: FormFields;
  @ViewChild('maxBalance') maxBalanceField: FormFields;
  @ViewChild('levelField') levelField: FormFields;

  showPopupInfoDownload: boolean = false;
  showPopupInfoErrorExport: boolean = false;
  reportError: string;
  acmList: any;
  loyaltyPermissions: Array<Permission>;

  // Visualizza tasto errori export in table Report
  public exportErrorPermission: boolean = false;
  public exportErrorPermissionCheck: PermissionConfiguration;

  @ViewChild('participantOverviewTable') participantOverviewTable: Campaign3KontableComponent;
  @ViewChild('excellReportTable') excellReportTable: Campaign3KontableComponent;


  constructor(
    public router: Router,
    public srvCalendar: CalendarTranslateService,
    private srvNotify: MessageService,
    private translate: TranslateService,
    private challengeService: ChallengeService,
    private challengeOverviewService: ChallengeOverviewService,
    private datePipe: DatePipe,
    private challengeOverviewExportService: ChallengeOverviewExportService,
    private permSrv: PermsService
  ) {
    this.loadStateList();

    var LOYALTYPERMISSIONS = this.permSrv.getLoyaltyPermission();
    this.exportErrorPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'challenge-error-export',
      method: ApiMethods.GET
    };
    Observable.zip(
      LOYALTYPERMISSIONS
    ).subscribe((
      [
        resLoyaltyPermissions,
      ]) => {
      this.loyaltyPermissions = resLoyaltyPermissions;
      this.exportErrorPermission = this.permSrv.checkPermission(this.loyaltyPermissions, this.exportErrorPermissionCheck);

    }
    )


  }


  ngOnInit() {

    this.fieldModel = {
      searchChallenge: null,
      searchLevel: null,
      searchDateStart: null,
      searchEndDate: null,
      acm: null,
      minBalance: null,
      maxBalance: null
    };

    // Observable traduzioni
    const challengeListTranslation$ = this.translate.get('challenge.challenge-list');

    const stateTranslations$ = this.translate.get([
      'challenge.export_status_starting',
      'challenge.export_status_completed',
      'challenge.export_status_completed_no_data',
      'challenge.export_status_failed'
    ]);

    const challengeList$ = this.challengeService.getChallenges();

    // Zip di TUTTO
    Observable.zip(challengeListTranslation$, stateTranslations$, challengeList$)
      .subscribe(([challengeListTrans, stateTranslations, resChallengeList]) => {

        // Breadcrumb
        this.breadcrumbs = [
          { code: 'bc1', description: challengeListTrans, routerLink: '/challenge-list' }
        ];

        // Stati (ora sicuri perché caricati)
        this.reportStateList = [
          { value: null, label: '' },
          { value: '0', label: stateTranslations['challenge.export_status_starting'] },
          { value: '1', label: stateTranslations['challenge.export_status_completed'] },
          { value: '2', label: stateTranslations['challenge.export_status_completed_no_data'] },
          { value: '3', label: stateTranslations['challenge.export_status_failed'] }
        ];

        // Challenge list
        if (resChallengeList && resChallengeList.data) {
          this.challengeList = resChallengeList.data.map(item => {
            return {
              ...item,
              display: item.id + ' - ' + item.title + ' (' + item.description + ')'
            };
          });
        }

        this.showBreadCrumb = true;
        this.readyTable = true;
        this.showTableExport = true;
      });


  }

  loadStateList() {
    this.reportStateList = [
      { value: null, label: '' },
      { value: '0', label: this.translate.instant('challenge.export_status_starting') },
      { value: '1', label: this.translate.instant('challenge.export_status_completed') },
      { value: '2', label: this.translate.instant('challenge.export_status_completed_no_data') },
      { value: '3', label: this.translate.instant('challenge.export_status_failed') }
    ];
  }

  getReportStatus(value: string): string {
    const item = this.reportStateList.find(rs => rs.value === value); // ora confronto stretto
    return item ? item.label : 'Unknown';
  }

  validateSearch(): boolean {
    let isValid = true;

    // 1️⃣ Validazione campi obbligatori tramite performValidation
    this.challengeField.performValidation();
    this.startDateField.performValidation();
    this.endDateField.performValidation();

    if (this.acmField) {
      this.acmField.performValidation();
    }
    if (this.showLevelsSelection && this.levelField) {
      this.levelField.performValidation();
    }

    if (this.minBalanceField) {
      this.minBalanceField.performValidation();
    }

    if (this.maxBalanceField) {
      this.maxBalanceField.performValidation();
    }

    // 2️⃣ Controllo validità campi
    if (
      !this.challengeField.valid ||
      !this.startDateField.valid ||
      !this.endDateField.valid ||
      (this.acmField && !this.acmField.valid) ||
      (this.showLevelsSelection && this.levelField && !this.levelField.valid) ||
      (this.minBalanceField && !this.minBalanceField.valid) ||
      (this.maxBalanceField && !this.maxBalanceField.valid)
    ) {
      console.warn('Form non valido');
      isValid = false;
    }

    // 3️⃣ Validazione incrociata di dominio: minBalance <= maxBalance
    if (
      isValid &&
      this.fieldModel.minBalance !== null &&
      this.fieldModel.maxBalance !== null &&
      this.fieldModel.minBalance > this.fieldModel.maxBalance
    ) {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('challenge.invalid_balance_range')
      });
      isValid = false;
    }

    return isValid;
  }

  //TODO rifare validazione livello e minmax  
  search(): void {
    // Nascondi la tabella subito
    this.showTable = false;

    // Usa setTimeout per forzare il nuovo ciclo di Angular
    setTimeout(() => {
      var valid = this.validateSearch();

      if (valid) {
        // Costruzione payload senza optional chaining
        var payload: OverviewPartecipantsDTO = {
          challengeId: (this.fieldModel.searchChallenge && this.fieldModel.searchChallenge.id)
            ? this.fieldModel.searchChallenge.id
            : null,
          levelId: (this.fieldModel.searchLevel && this.fieldModel.searchLevel.value)
            ? this.fieldModel.searchLevel.value
            : null,
          startDate: this.toApiDate(this.fieldModel.searchDateStart),
          endDate: this.toApiDate(this.fieldModel.searchEndDate),
          challengeAcmId: (this.fieldModel.acm && this.fieldModel.acm.value)
            ? this.fieldModel.acm.value
            : null,
          balanceMin: (this.fieldModel.minBalance !== null && this.fieldModel.minBalance !== undefined)
            ? this.fieldModel.minBalance
            : null,
          balanceMax: (this.fieldModel.maxBalance !== null && this.fieldModel.maxBalance !== undefined)
            ? this.fieldModel.maxBalance
            : null
        };

        console.log('SEARCH PAYLOAD:', payload);

        // Salvataggio filtri nel service
        this.challengeOverviewService.setOverviewFilters(payload);

        // Reset error/loading
        this.participantsError = false;
        this.isLoadingParticipants = false;

        // Mostra la tabella
        this.showTable = true;
      }
    }, 0);
  }


  private toApiDate(date: Date | string): string | null {
    let result: string | null = null;

    if (date) {
      result = this.datePipe.transform(date, 'yyyy-MM-dd');
    }

    return result;
  }
  showLevelsSelection: boolean = false;


  private elaborateChallengeDetails(details: ChallengeDetail[]): ChallengeDetailElaborated[] {
    const elaborated: ChallengeDetailElaborated[] = [];

    details.forEach(detail => {

      // Se manca challengeDetailAcm, lo tratto come array vuoto
      const acmList = detail.challengeDetailAcm ? detail.challengeDetailAcm : [];

      acmList.forEach(acm => {

        // Protezione di tutti i livelli annidati per evitare undefined
        const challengeAcm = acm && acm.challengeAcm ? acm.challengeAcm : null;
        const acmIdObj = challengeAcm && challengeAcm.acmId ? challengeAcm.acmId : null;

        const acmDescription = acmIdObj && acmIdObj.description ? acmIdObj.description : '';
        const controlAcm = acmIdObj && acmIdObj.id ? acmIdObj.id : null;

        elaborated.push({
          id: detail.id ? detail.id : null,
          challengeId: detail.challengeId ? detail.challengeId : null,
          levelName: detail.description ? detail.description : '',
          challengeDetailAcmId: acm && acm.id ? acm.id : null,
          acmDescription: acmDescription,
          controlAcm: controlAcm,
          minimumTrashold: acm && acm.minRangeValue ? acm.minRangeValue : null,
          maximumTrashold: acm && acm.maxRangeValue ? acm.maxRangeValue : null,
          pushNotify: detail.flgPushNotification ? detail.flgPushNotification : '0',
          pushNotifyText: detail.pushNotificationText ? detail.pushNotificationText : '',
          numRewards: detail.numRewards ? detail.numRewards : null
        });

      });

    });

    return elaborated;
  }

  onChallengeSelected(): void {
    const selectedChallenge = this.fieldModel && this.fieldModel.searchChallenge;
    this.readyAcm = false;
    this.fieldModel.acm = null;
    this.fieldModel.searchLevel = null;   // <-- QUESTO ti manca
    this.levelsList = [];
    this.acmList = [];
    this.showLevelsSelection = false;

    if (!selectedChallenge || !selectedChallenge.id) {
      this.acmList = [];
      this.readyAcm = true;
      return;
    }

    const acm$ = this.challengeService.getChallengeAcm(selectedChallenge.id)
      .pipe(
        catchError(error => {
          console.error('Errore durante il recupero degli ACM:', error);
          return Observable.of([]);
        })
      );

    const challengeDetails$ = this.challengeService.getCampaignChallengeDetails(selectedChallenge.id)
      .pipe(
        catchError(error => {
          console.error('Errore durante il recupero di azioni delle campagne:', error);
          return Observable.of([]);
        })
      );

    // Combinazione con zip
    Observable.zip(acm$, challengeDetails$)
      .subscribe(([acmResponse, challengeDetails]) => {

        // ACM
        if (acmResponse && acmResponse.length > 0) {
          this.acmList = acmResponse.map(item => {
            return {
              value: item.id,
              label: item.acmId.description
            };
          });

          //  AUTO-SELEZIONE se uno solo
          if (this.acmList.length === 1) {
            this.fieldModel.acm = this.acmList[0];
          }

        } else {
          this.acmList = [];
          this.fieldModel.acm = null; // reset sicurezza
        }

        // Challenge details
        this.challengeDetailList = challengeDetails;
        this.challengeDetailListElaborated =
          this.elaborateChallengeDetails(challengeDetails);

        this.levelsList = this.challengeDetailListElaborated.map(item => {
          return {
            value: item.id,
            label: item.levelName
          };
        });

        this.showLevelsSelection =
          this.challengeDetailListElaborated.length > 0;

        // Date
        if (selectedChallenge.dateStart && selectedChallenge.dateEnd) {
          const startDate = this.formatToDate(selectedChallenge.dateStart);
          const endDate = this.formatToDate(selectedChallenge.dateEnd);

          this.fieldModel.searchDateStart = startDate;
          this.fieldModel.searchEndDate = endDate;

          this.endDateField.minDate = startDate;
          this.endDateField.maxDate = endDate;
        }

        this.readyAcm = true;
      });
  }

  formatToDate(dateInput: Date | string): Date | null {
    if (!dateInput) return null;

    if (dateInput instanceof Date) {
      return isNaN(dateInput.getTime()) ? null : dateInput;
    }

    // input come "YYYY-MM-DD"
    const parts = (dateInput as string).split('-');
    if (parts.length !== 3) return null;

    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // 0-based
    const day = parseInt(parts[2], 10);

    const d = new Date(year, month, day);
    return isNaN(d.getTime()) ? null : d;
  }

  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.log("Nessuna route implementata");
    }
  }


  //EXPORT dei risultati numerici
  onExportParticipants(): void {
    const payload: OverviewPayload = this.buildOverviewPayload();

    this.challengeOverviewService.exportOverviewParticipants(payload).subscribe({
      next: (res: Blob) => {
        console.log('Export Overview Participants completato:', res);
      },
      error: (err) => console.error('❌ Errore durante l’export dei partecipanti:', err)
    });
  }
  buildOverviewPayload(): OverviewPayload {
    return {
      searchChallenge: this.fieldModel.searchChallenge,
      searchDateStart: this.fieldModel.searchDateStart,
      searchEndDate: this.fieldModel.searchEndDate,
      acm: this.fieldModel.acm,
      minBalance: this.fieldModel.minBalance,
      maxBalance: this.fieldModel.maxBalance
    };
  }
  downloadExcel(filters: any): void {
    console.log(filters);
    this.showPopupInfoDownload = true;
    let offset: number | null = null;
    let limit: number | null = null;
    let searchFilters: Array<{ key: string; value: string }> | undefined;

    if (filters) {
      if (filters.offset !== undefined) {
        offset = filters.offset;
      }

      if (filters.limit !== undefined) {
        limit = filters.limit;
      }

      if (filters.search !== undefined) {
        searchFilters = filters.search;
      }
    }

    this.challengeOverviewService
      .downloadExcell(offset, limit, searchFilters)
      .subscribe(res => {
        console.log(res);

      });
  }

  onClosePopupInfoDownload(): void {
    this.showPopupInfoDownload = false;
  }
  getFileName(path: string): string {
    if (!path) {
      return 'not-found';
    }
    const normalizedPath = path.replace(/\\/g, '/');
    return normalizedPath.substring(normalizedPath.lastIndexOf('/') + 1);
  }

  toggleMenu(row: ChallengeExportReportDTO): void {
    var id = row.id;

    if (this.showMenu && this.currentOpenedRow !== id) {
      this.showMenu = false;
    }

    this.currentOpenedRow = id;
    this.showMenu = !this.showMenu;
  }
  @HostListener('document:click', ['$event'])
  onClick(event: any): void {
    var target = event.target;

    if (
      (!target.closest || !target.closest('.dropdown-menu')) &&
      (!target.closest || !target.closest('.d-flex'))
    ) {
      this.showMenu = false;
    }
  }
  //CRUD

  //DELETE
  reportToDelete: ChallengeExportReportDTO;
  displayDeleteDialog: boolean = false;
  deleteReport(row: ChallengeExportReportDTO) {
    this.showMenu = false;
    this.reportToDelete = row;
    this.displayDeleteDialog = true;
  }
  closePopupDelete(): void {
    this.displayDeleteDialog = false;
  }
  onDefinitiveDelete(row: ChallengeExportReportDTO): void {
    this.challengeOverviewExportService.deleteReport(row.id).subscribe({
      next: () => {
        this.displayDeleteDialog = false;

        this.srvNotify.add({
          severity: 'success',
          summary: this.translate.instant('common.success'),
          detail: this.translate.instant('challenge.delete_success'),
          life: 5000
        });

        this.excellReportTable.refresh();
      },
      error: (err) => {
        console.error('Errore durante la cancellazione challenge:', err);

        this.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('challenge.delete_error'),
          life: 5000
        });
      }
    });
  }


  obtainReport(row: ChallengeExportReportDTO) {
    this.challengeOverviewExportService.obtainReport(row.id).subscribe({
      next: (res: any) => {
        this.displayDeleteDialog = false;

        // Estraggo solo l'ultima parte del percorso del file
        let fileName = row.fileName || 'report.csv';
        if (fileName.includes('/') || fileName.includes('\\')) {
          fileName = fileName.split(/[\\/]/).pop();
        }

        const reader = new FileReader();
        reader.onload = () => {
          try {
            const jsonRes = JSON.parse(reader.result as string);
            if (jsonRes && jsonRes.rsp_data) {
              const csvBlob = new Blob([jsonRes.rsp_data], { type: 'text/csv' });
              FileSaver.saveAs(csvBlob, fileName);
            }
          } catch (e) {
            console.error('Errore durante il parsing del JSON dal Blob:', e);
          }
        };
        reader.readAsText(res);

        this.srvNotify.add({

          severity: 'success',
          summary: this.translate.instant('common.success'),
          detail: this.translate.instant('challenge.obtain_success'),
          life: 5000
        });
        this.showMenu = false;

        this.excellReportTable.refresh();
      },
      error: (err) => {
        console.error('Errore durante l’ottenimento challenge:', err);

        this.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('challenge.obtain_error'),
          life: 5000
        });
      }
    });
  }

  infoErrorExport(row: ChallengeExportReportDTO): void {
    this.reportError = row.error;
    this.showPopupInfoErrorExport = true;
  }
  onClosePopupInfoErrorExport(): void {
    this.showPopupInfoErrorExport = false;
  }


}








// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-graphics-details/challenge-graphics-details.component.ts